import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import FormPage from './FormPage';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import "@fontsource/poppins"; // domyślnie waga 400
// lub określone wagi i style:
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/400-italic.css";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/pl'; 
import customParseFormat from 'dayjs/plugin/customParseFormat';

// Wyciszenie nieszkodliwego błędu "ResizeObserver loop ..." — pokazuje go tylko dev-overlay
// (webpack-dev-server) jako crash; w produkcji nie występuje i nie wpływa na działanie formularza.
const dismissResizeObserverOverlay = (message?: string): boolean => {
  if (!message || !message.includes('ResizeObserver loop')) return false;
  ['webpack-dev-server-client-overlay', 'webpack-dev-server-client-overlay-div'].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.style.display = 'none';
  });
  return true;
};
window.addEventListener('error', (e) => {
  if (dismissResizeObserverOverlay(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// Roboto font - :)
// Tworzymy motyw
// https://fonts.google.com/specimen/Poppins
const theme = createTheme({
  palette: {
    primary: {
      main: '#009688', // Updated primary color to #009688
    },
  },
  typography: {
    fontFamily: '"Poppins", sans-serif', // Set font family to Poppins
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            '&.Mui-focused': {
              borderColor: '#009688', // Updated focus color for TextField to match primary color
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#009688', // Updated hover color for Button to match primary color
          },
        },
      },
    },
  },
});
dayjs.extend(customParseFormat); // <-- TO DODAJ
dayjs.locale('pl'); // <- ustaw domyślną lokalizację

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pl">
      <ThemeProvider theme={theme}>
        <BrowserRouter basename="/f">
          <Routes>
            <Route path="/" element={<FormPage />} />
            <Route path="/:token" element={<FormPage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </LocalizationProvider>
  </React.StrictMode>
);
reportWebVitals();
